import React from 'react';
import Icon from '../AppIcon';

/**
 * Inline permission-denied banner.
 * Usage: show this when a viewer tries to trigger a restricted action.
 */
const PermissionDenied = ({ message = 'You do not have permission to perform this action.', className = '' }) => {
  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 bg-destructive/10 border border-destructive/20 rounded-lg text-sm text-destructive ${className}`}
      role="alert"
    >
      <Icon name="ShieldOff" size={18} className="flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
};

export default PermissionDenied;
